import { render } from "./MyWantToBuyList.vue?vue&type=template&id=c4e9785c&scoped=true&ts=true&lang=pug"
import script from "./MyWantToBuyList.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyWantToBuyList.vue?vue&type=script&lang=ts&setup=true"

import "./MyWantToBuyList.vue?vue&type=style&index=0&id=c4e9785c&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e9785c"]])

export default __exports__